export default __webpack_public_path__ + "static/media/49t.928449c6.jpg";